<template>
    <ReferralHeader :header="header" />
    <div class="row side-nav">
        <div class="col-2 vertical-nav-bar mt-2">
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <a
                    v-for="tab in tabs"
                    :class="`nav-link ps-4 ms-2 d-flex justify-content-between ${activeTab === tab.id ? 'actived' : ''}`"
                    :id="`v-pills-${tab.id}`"
                    data-bs-toggle="pill"
                    :href="`#v-pills-${tab.id}`"
                    role="tab"
                    :key="tab.id"
                    aria-selected="true"
                    @click="handleTabChange(tab)"
                >
                    {{ tab.name }}
                    <div class="heads_up">
                        <span
                            class="fa fa-exclamation-triangle text-danger"
                            aria-hidden="true"
                            v-if="showErrors(tab)"
                        ></span>
                        <span
                            class="fa fa-exclamation-triangle text-warning"
                            aria-hidden="true"
                            v-else-if="showWarnings(tab)"
                        ></span>
                        <span class="fa fa-check text-success" aria-hidden="true" v-if="showSuccess(tab)"></span>
                        <span
                            :class="`heads-up__count ${showErrors(tab) ? 'error-count' : 'warning-count'}`"
                            v-if="showWarnings(tab) || showErrors(tab)"
                        >
                            {{ showErrors(tab) ? numberOfErrors(tab) : numberOfWarnings(tab) }}
                        </span>
                    </div>
                </a>
            </div>
        </div>

        <div class="col-10 edit_form">
            <div class="tab-content mt-2" id="v-pills-tabContent">
                <div>
                    <MciLayout :content-wrapper="`content-wrapper`">
                        <template #content>
                            <div class="card material-card flex-column h-100 overflow-auto">
                                <slot name="forms"> </slot>
                            </div>
                        </template>
                    </MciLayout>
                </div>
            </div>
            <slot name="buttons"> </slot>
        </div>
    </div>
</template>

<scss src="./TabsLayout.scss"></scss>
<script src="./TabsLayout.ts"></script>
